/* eslint-disable import/default */
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createHashHistory as createHistory } from 'history';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import { AppContainer } from 'react-hot-loader';
import GoogleAnalytics from 'react-ga';
import { authorize, isUserOnUserProfilePage } from './businessLogic/authorizator.js';
require.context('../config/language-resources-default', true, /.*/);
require.context('../config/external-link-resources', true, /.*/);
require.context('./businessLogic', true, /.*/); //TODO : we only want the intlTelInputUtils library from this location, but his is loading ALL files as static into the output folder of the build
require('./businessLogic/logger.js'); //initialize logger
import { pageChanged } from './actions/navigationBar.js';
import { configureStore } from './store/configureStore';
import initialState from './store/initialState';
const store = configureStore(initialState);
import Routes from './routes';
require('./loadAssets');
import { FetchInterceptor } from './businessLogic/fetchInterceptor';
import { hideGlobalMessage } from './actions/globalMessage';
import { redirectToInternalLink, currentPage } from './businessLogic/redirector';
import { getHotJarTrackingId, hideHotJarFeedbackPlugin } from './businessLogic/hotJarLoader';
import {
  requestPermissionForDesktopAlerts,
  playAudioAlert,
  REMOTE_CALLER_ADD_SOUND_PATH,
} from './businessLogic/notification';
import styleVariable from '../styles/sass/variables.scss';
import { isAnyOverlayFormVisible } from './businessLogic/form';
import { requestHeartbeat } from 'actions/networkHealthStatus';
import { queueESEvents, ESEventTypes } from './businessLogic/logEventToElasticSearch';

require.context('../config/stubs', true, /.*/);
require.context('../config/iis', true, /.*/);

if (!window.APP.IMAGES.MeetingRoomIcon.default.indexOf('http') < 0) {
  let a11y = require('react-a11y');
  a11y(React, { ReactDOM: ReactDOM }); //ACCESSIBILITY INITIALIZAER
}

window.getState = function () {
  return store.getState();
};

function initialize() {
  $('body').delegate('.field input', 'change paste keyup blur ', function () {
    //this is to intercept changes on elements created or that will be created in the page

    console.log('changed');
    let $this = $(this);
    if (this.value !== '') {
      $this.addClass('filled');
    } else {
      $this.removeClass('filled');
    }
  });
  $('body').delegate('.field .text.default', 'change paste keyup', function () {
    //dropdowns
    let $this = $(this);
    if (this.value !== '') {
      $this.addClass('filled');
    } else {
      $this.removeClass('filled');
    }
  });

  $(document.body).on('click', handleGlobalClickEvent);

  function handleGlobalClickEvent(e) {
    ///Browser (at the moment safari) does not play the ding notification. so we manually play the notification (muted) as user interacts with VCM
    //After this the ding is getting heard
    if (!window.initialSoundPlayed && e.hasOwnProperty('originalEvent')) {
      //we check if the click event is not programatically fired but by in actual the user interaction
      playAudioAlert(REMOTE_CALLER_ADD_SOUND_PATH, true);
      window.initialSoundPlayed = true; //means the sound was played, so we dont need to play again
    }
  }

  function handleGlobalKeyDownEvent() {
    if (event.which == 13) {
      if (
        !event.target.classList.contains('dropdown') &&
        !event.target.classList.contains('color-button') &&
        !event.target.classList.contains('textarea')
      ) {
        window.$('.modal button[data-group].color-button:visible').click();
      }
    } else if (event.which == 27) {
      if (!event.target.classList.contains('dropdown')) {
        window.$('.modal button.color-bad-things:visible').click();
      }
    }
  }

  $(document.body).on('keydown', handleGlobalKeyDownEvent);

  // On focus (back on tab), validate if we still have a valid session
  $(document).ready(function () {
    document.addEventListener('visibilitychange', function () {
      console.log('===> document.hidden = ' + document.hidden);
      if (!document.hidden && !isUserOnUserProfilePage(store)) {
        // user has just shifted back to this browser tab,
        // re-authorise session
        window.globalAuthorize();
        // request pubnub heartbeat for this user
        requestHeartbeat();
      }
    });
  });

  requestPermissionForDesktopAlerts();

  window.onbeforeunload = function () {
    // if any form is visible with input controls, confirm with user before navigating away
    if (isAnyOverlayFormVisible()) {
      return true;
    } else {
      return null;
    }
  };
}

getHotJarTrackingId(); //gets The HotJar id and continue the subsequent functionality.

const calculateCurrentPage = () => {
  if (window.location.href.indexOf('meeting-room/manage-users') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.MeetingRoomManageUsers.PageHeaderTitle));
  } else if (window.location.href.indexOf('meeting') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.ViewMeetingRoom.Title));
  } else if (window.location.href.indexOf('waiting-area/view-one') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.ViewOneWaitingArea.Title));
  } else if (window.location.href.indexOf('waiting-area/manage-users') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle));
  } else if (window.location.href.indexOf('waiting-area/manage-tags') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle));
  } else if (window.location.href.indexOf('organisational-unit/manage-users') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle));
  } else if (window.location.href.indexOf('waiting-area') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.ViewWaitingArea.Title));
  } else if (window.location.href.indexOf('profile') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.UserProfile.TitleClean));
  } else if (window.location.href.indexOf('organisational-unit/manage-tags') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle));
  } else if (window.location.href.indexOf('organisational-unit') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.ViewAllOrgUnit.Title));
  } else if (window.location.href.indexOf('report') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.MainReport.Title));
  } else if (window.location.href.indexOf('user') > -1) {
    store.dispatch(pageChanged(window.APP.LANGUAGE.ManageAllUsers.Title));
  }
};

const setFavIconUrl = () => {
  var link = document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = window.APP.IMAGES.favIconUrl;
  document.getElementsByTagName('head')[0].appendChild(link);
};

const verifyPublicPage = () => {
  var privatePages = new Set([
    '/meeting',
    '/waiting',
    '/profile',
    '/organisational',
    '/meeting-room',
    '/waiting-area',
    '/user/profile',
    '/groups/view-all',
    '/organisational-unit/view-all',
    '/organisational-unit/manage-tags',
    '/meeting-room/view-all',
    '/waiting-area/view-all',
    '/waiting-area/view-one',
    '/waiting-area/manage-users',
    '/waiting-area/manage-tags',
  ]);
  var page = currentPage();
  if (privatePages.has(page)) {
    return false;
  }
  return true;
};

// Globally available funciton to authorize from anywhere in whole js app
window.globalAuthorize = () => {
  authorize(undefined, store.dispatch);
};

const history = window.APP.CONFIGURATION.HASH_HISTORY == false ? createBrowserHistory() : createHistory();

history.listen((location, action) => {
  if (window.APP.CONFIGURATION.GOOGLE_ANALYTICS_PROPERTY_ID) {
    GoogleAnalytics.pageview(
      location.pathname,
      null,
      window.APP.CONFIGURATION.GOOGLE_ANALYTICS_PAGE_TITLE_MASK || window.document.title
    );
  }
  queueESEvents(ESEventTypes.RdirectingTo, location.pathname, 'eventType&eventValue', null, null, true, 'info');
});

//due to change in react router v4 we dont have the history object static/exposed. therefore making our wrapper
window.globalHistory = () => {
  return history;
};

history.listen(function (ev) {
  authorize(undefined, store.dispatch, undefined, false); //we dont want to make calls again and again to basic profile on page navigation
  calculateCurrentPage();
});

FetchInterceptor.dispatch = store.dispatch; //setting Fetchinterceptor dispatch method
window.styleVariable = styleVariable;
if (window.APP.CONFIGURATION.HASH_HISTORY == true) {
  window.launchApp = () => {
    authorize(undefined, store.dispatch);
    createRoot(document.getElementById('app')).render(
      <AppContainer>
        <Provider store={store}>
          <Router history={history}>
            <Routes dispatch={store.dispatch} />
          </Router>
        </Provider>
      </AppContainer>
    );
    calculateCurrentPage();
    setFavIconUrl();
    initialize();
  };

  $(document).ready(function () {
    window.waitingForLinksInterval = setInterval(() => {
      if (window.APP.EXTERNAL_LINKS != undefined && !window.isAppLaunched) {
        window.isAppLaunched = true;
        window.launchApp();
        if (!window.showingOverLay) {
          //showing overlay is property only set to true in the logout function, at authroizator.js
          window.$('#overlay').fadeOut(); //for hiding spinner
        }
        clearInterval(window.waitingForLinksInterval);
      } else {
        //the application will be launched from config.js
      }
    }, 200); ///wait before rendering so the browser loads the css
  });
} else if (window.APP.CONFIGURATION.HASH_HISTORY == false) {
  window.launchApp = () => {
    authorize(undefined, store.dispatch);
    createRoot(document.getElementById('app')).render(
      <AppContainer>
        <Provider store={store}>
          <Router history={history}>
            <Routes dispatch={store.dispatch} />
          </Router>
        </Provider>
      </AppContainer>
    );
    calculateCurrentPage();
    setFavIconUrl();
    initialize();

    if (module.hot) {
      module.hot.accept('./routes', () => {
        const NewRoot = require('./routes').default;
        createRoot(document.getElementById('app')).render(
          <AppContainer>
            <Provider store={store}>
              <Router history={history}>
                <NewRoot />
              </Router>
            </Provider>
          </AppContainer>
        );
      });
    }
  };

  $(document).ready(function () {
    setTimeout(() => {
      if (window.APP.EXTERNAL_LINKS != undefined) {
        window.isAppLaunched = true;
        window.launchApp();
        if (!window.showingOverLay) {
          //showing overlay is property only set to true in the logout function, at authroizator.js
          window.$('#overlay').fadeOut(); //for hiding spinner
        }
      } else {
        //the application will be launched from config.js
      }
    }, 200); ///wait before rendering so the browser loads the css
  });
  $(document).ready(function () {
    // whenever user click any of the hotjar option, handler will check if screenshot element exists or not.
    // if it exists, handler will remove it from DOM.
    // .on will work as live() event as we have passed the selector. will work on dynamic content as well.
    $(document.body).on(
      'click',
      "div[class$='_emotion_option'],div[class*='_emotion_option'],span[class$='_emotion_text'],span[class*='_emotion_text']", // eslint-disable-line  quotes
      function () {
        try {
          // if screen shot element found...
          if ($('[class$="_icon-select-element"]').length > 0) {
            // delete screen shot element
            $('[class$="_icon-select-element"]').remove();
          }
        } catch (ex) {
          // hide hotjar due to error
          hideHotJarFeedbackPlugin();
          console.warn('Hiding Hotjar due to exception: ', ex);
        }
      }
    );
  });
}
